import React from "react";
import Aux from "../components/Aux/Aux";

const EmptyPage = () => {
  return (
      <Aux />
  );
};

export default EmptyPage;